import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import DiscountIcon from './discountIcon';

export const DiscountImage = styled(DiscountIcon)(({ theme }) => ({
  width: '40px',
  height: '60px',
  position: 'absolute',
  left: 'auto',
  right: 20,
  top: 0,
  color: theme.palette.secondary.main,
  borderRadius: '5px',
  zIndex: 100,
}));

export const DiscountTypography = styled(Typography)({
  color: 'White',
  fontSize: '14px',
  position: 'absolute',
  left: 'auto',
  right: '22px',
  top: '30px',
  fontWeight: 'bold',
  zIndex: 100,
});

export const ImageNavigationBox = styled(Box)({
  height: '100%',
  backgroundColor: 'transparent',
  zIndex: 1,
  top: 0,
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
});
